import React from 'react';

export class InlineSvg extends React.Component {

  constructor(init) {

    super(init);
    this.state = {
        svg: null,
        svgAttr: null,
    }
  }

  componentWillMount() {
    fetch(this.props.src)
  		.then(response => response.text())
  		.then((output) => this.onFetchSvg(output));
  }

  onFetchSvg = (textData) => {
    const blacklist = [
        'xmlns:a',
        'xmlns:xlink'
    ];
    const parser = new DOMParser();
    const element = parser.parseFromString(textData, "text/xml");
    const singleSvg = element.getElementsByTagName("svg")[0];


    const rootElementAttributes = Array.from(
        singleSvg.attributes
      ).map(a => a.localName)
      .filter((attr) => {
          return !blacklist.includes(attr);
      }).reduce((obj, attr) => {
          obj[attr] = singleSvg.getAttribute(attr);
          return obj;
      }, {});

    const rand = Math.random().toString().replace('.', '');
    const styleTags = Array.from(singleSvg.getElementsByTagName('style'));

    // Ensure the linear-gradient IDs are unique.
    {
      const regex = new RegExp([
        '(', // start capture group
        'fill:\\s*', // fill:<any whitespace>
        'url\\(#', // url(#
        ')(', // start capture group
        '[^)]+', // anything except for a closing bracket
        ')(', // start capture group
        '\\)', // find closing the closing bracket for "url("
        ')', // end capture group
      ].join(''), 'g');
      const replace = (substr, start, id, end, str) => {
        const newId = id + '-' + rand;
        singleSvg.getElementById(id).setAttribute('id', newId);
        return start + newId + end;
      };
      styleTags.forEach((style) => {
        style.innerHTML = style.innerHTML.replace(regex, replace);
      });
    }

    // Ensure all class names are unique.
    {
      const regex = new RegExp(
        [
          '(\\.)', // find a "."
          '(', // start capture group
          '[a-zA-Z0-9_-]+', // find alpha numeric
          ')\\s*(', // end & start capture group
          '[^a-zA-Z0-9_-]', // not alpha numeric
          ')', // end capture group
        ].join(''),
        'g'
      );
      const replace = (substr, start, selector, end, str) => {
          const newSel = selector + '-' + rand;
          const els = singleSvg.getElementsByClassName(selector);
          // Replace old class with new one.
          Array.from(els).forEach((el) => {
            el.classList.remove(selector);
            el.classList.add(newSel);
          });
          return '.' + newSel + end;
      };
      styleTags.forEach((style) => {
        style.innerHTML = style.innerHTML.replace(regex, replace);
      })
    }

    this.setState({
      svg: singleSvg,
      svgAttr: rootElementAttributes,
    });

  }

  render() {
    if(this.state.svg === null){
      return "svg";
    } else {
      const props = Object.assign({}, this.state.svgAttr, this.props);
      delete props.src;
      return (
        <svg {...props} dangerouslySetInnerHTML={{__html: this.state.svg.innerHTML}} />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/inlineSvg.js